import { MapPin, Clock, Phone, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const contactInfo = [
  {
    icon: MapPin,
    label: "Dirección",
    value: "Carrer Exemple 123, Girona",
  },
  {
    icon: Clock,
    label: "Horario",
    value: "L\u2013V 10:00\u201313:30 y 16:30\u201319:30 \u00b7 S 10:00\u201313:00",
  },
  {
    icon: Phone,
    label: "Teléfono",
    value: "+34 600 000 000",
  },
];

export const ContactSection = () => {
  return (
    <section
      id="contacto"
      data-testid="contact-section"
      className="py-16 md:py-20 border-t border-border/40"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10">
          <span className="text-sm font-medium tracking-wide uppercase text-primary/80 mb-3 block">
            Contacto
          </span>
          <h2
            data-testid="contact-title"
            className="text-2xl md:text-3xl font-bold text-foreground tracking-tight"
          >
            Encuéntranos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto mb-8">
          {contactInfo.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                data-testid={`contact-info-${index}`}
                className="text-center"
              >
                <div className="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center mx-auto mb-3">
                  <Icon className="w-5 h-5 text-primary" strokeWidth={1.5} />
                </div>
                <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1">
                  {item.label}
                </p>
                <p className="text-sm font-medium text-foreground">{item.value}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <a
            href="https://www.google.com/maps/search/Carrer+Exemple+123+Girona"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              data-testid="contact-map-btn"
              variant="outline"
              className="rounded-full px-6 h-10 text-sm font-medium border-2 border-primary/15 text-foreground hover:bg-secondary/60 hover:border-primary/30 transition-colors"
            >
              <ExternalLink className="w-4 h-4 mr-2" strokeWidth={1.5} />
              Cómo llegar
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
